import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import CvpPanelLink from "../../../Components/Panel/CvpPanelLink";
import { getRedirectProps } from "../../../WSUtils/urlUtils";
import { UserInfoContext } from "../../../WSUtils/UserInfoContext";
import { concatClassnames } from "../../../WSUtils/util";
import {
  CVPSearchParams,
  queryStringStore,
} from "../../../WSUtils/wsQueryStringStore";
import styled from "styled-components";
import { device } from "../../../WSUtils/constants/mediaQueries";

interface MessageProps {
  date: string;
  name: string;
  fromTo: string;
  id: string;
  className?: string;
}
const MessagePanel: React.FC<MessageProps> = observer((props) => {
  const { date, name, fromTo, id, className } = props;

  const userInfo = useContext(UserInfoContext);

  const { href, target, onClick } = getRedirectProps("/messages", {
    userInfo,
    mergeQs: {
      [CVPSearchParams.cvpmsgid]: id,
    },
  });

  const currentMessageId =
    queryStringStore.qs[CVPSearchParams.cvpmsgid]?.toString();

  const isActive = id === currentMessageId;

  return (
    <StyledMessagePanel
      href={href}
      target={target}
      onClick={onClick}
      className={
        !!isActive
          ? `active cvp-msg-panel ${concatClassnames([className])}`
          : `cvp-msg-panel ${concatClassnames([className])}`
      }
    >
      <i className="pi pi-envelope"></i>
      <span>{date}</span>
      <span>|</span>
      <div>
        <span className="mr-1">{fromTo}</span>
        <span>{name}</span>
      </div>
    </StyledMessagePanel>
  );
});

export default MessagePanel;

export const StyledMessagePanel = styled(CvpPanelLink)`
  &.cvp-msg-panel {
    color: var(--text-color);
    text-decoration: none;

    :hover {
      background-color: var(--primary-50);
      -webkit-transition: all ease-out 0.3s;
      -moz-transition: all ease-out 0.3s;
      -o-transition: all ease-out 0.3s;
      transition: all ease-out 0.3s;
    }

    &.active {
      background-color: var(--primary-50);
    }
  }
  @media ${device} {
  }
`;
